import type { CatalogResponse } from '@nadoutong/contracts';
import { useQuery } from '@tanstack/react-query';
import type { UseQueryResult } from '@tanstack/react-query';
import { useSession } from '../hooks/useSession.tsx';
import { getCatalogForBrand } from './catalog.ts';

export const CATALOG_QUERY_KEY = ['catalog'] as const;

/**
 * Nxtpath brand catalog query — the brand is pinned here (epic #950
 * PR-8, formerly a shell over the console-shared `useCatalogForBrand`).
 */
export function useCatalog(): UseQueryResult<CatalogResponse> {
  const { fetchImpl } = useSession();
  return useQuery({
    queryKey: CATALOG_QUERY_KEY,
    queryFn: ({ signal }) => getCatalogForBrand(fetchImpl, 'nxtpath', signal),
    staleTime: 300_000,
  });
}
